// extracted by mini-css-extract-plugin
module.exports = {"bsBtn":"Button_bsBtn__ua7lC","iconSpan":"Button_iconSpan__Va8hY","iconHolder":"Button_iconHolder__246Ym","altColor":"Button_altColor__6TkdF","disabled":"Button_disabled__4OfYr"};